import { createContext, useContext, useState } from "react";
import React from 'react'
const QuizAppContext = createContext();

const QuizAppProvider = ({ children }) => {

    const username="Isha";
    const seconds=180;
    
    const [countdown,setCountDown]=useState(seconds);
    const [showResult, setShowResult] = useState(false);
    const [takeTime,setTakeTime]=useState(0);
    return (
        <QuizAppContext.Provider value={{username ,
         countdown,setCountDown ,
         showResult,setShowResult,seconds,
         takeTime,setTakeTime
        }}>
            {children}
        </QuizAppContext.Provider>
    )
}

const useQuizContext=()=>{
    return useContext(QuizAppContext)
}
export {QuizAppContext,QuizAppProvider,useQuizContext}